import { Button as HeadlessUiButton } from "@headlessui/react"

const ArrowRightIcon = () => (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.125 10.0002L12 17.8479"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M20.0938 10L11.0937 2"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M2 9.87805L19.9389 9.87805"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
)

interface Props {
  className?: string
  disabled?: boolean
  iconOnly?: boolean
  onClick?: () => void
  title: string
  type?: "button" | "submit" | "reset"
}

export default function Button({
  className = "",
  disabled = false,
  iconOnly = false,
  onClick,
  title,
  type = "button",
}: Props) {
  if (iconOnly) {
    className = `${className} !w-auto !p-6`
  }

  return (
    <HeadlessUiButton
      className={`${className} custom-button-primary`}
      disabled={disabled}
      onClick={onClick}
      title={title}
      type={type}
    >
      {iconOnly ? <ArrowRightIcon /> : title}
    </HeadlessUiButton>
  )
}
